module.exports = __webpack_public_path__ + "static/media/mm.e5d8d901.svg";